export const aurora = {
  50:  '#E5F8FF',
  100: '#BFEEFF',
  200: '#8BDFFF',
  300: '#52CCFF',
  400: '#1FB5FA',
  500: '#00C9FC',
  600: '#0098D8',
  700: '#0073AC',
} as const;

export const midnight = {
  500: '#1C3A6A',
  600: '#152A4D',
  700: '#0F1E36',
  800: '#0A1424',
  900: '#050B17',
  950: '#03070F',
} as const;

export const ice = {
  100: '#EAF4FF',
  200: '#C7DFFA',
  300: '#9CC2EE',
  500: '#5C8AB8',
} as const;

/**
 * Figma neutral/* and text/* (white-based). The customer app uses these in
 * place of the ice text; `text` below stays on ice for the back office.
 */
export const textNeutral = {
  white:      '#FFFFFF',
  black:      '#000000',
  primary:    '#FFFFFF',
  body:       'rgba(255, 255, 255, 0.65)',
  tertiary:   'rgba(255, 255, 255, 0.55)',
  decorative: 'rgba(255, 255, 255, 0.35)',
} as const;

/** White at N% — the fills and strokes Figma paints as white with opacity. */
export const whiteAlpha = {
  1:  'rgba(255, 255, 255, 0.01)',
  2:  'rgba(255, 255, 255, 0.02)',
  4:  'rgba(255, 255, 255, 0.04)',
  5:  'rgba(255, 255, 255, 0.05)',
  6:  'rgba(255, 255, 255, 0.06)',
  8:  'rgba(255, 255, 255, 0.08)',
  10: 'rgba(255, 255, 255, 0.10)',
  12: 'rgba(255, 255, 255, 0.12)',
  14: 'rgba(255, 255, 255, 0.14)',
  18: 'rgba(255, 255, 255, 0.18)',
  22: 'rgba(255, 255, 255, 0.22)',
  85: 'rgba(255, 255, 255, 0.85)',
} as const;

export const semantic = {
  success: '#22C58B',
  warning: '#FFB547',
  error:   '#FF5965',
  info:    '#00C9FC',
} as const;

export const surface = {
  app:        midnight[900],
  card:       midnight[800],
  cardElev:   midnight[700],
  overlay:    'rgba(3, 7, 15, 0.65)',
  hairline:   'rgba(255, 255, 255, 0.06)',
  divider:    'rgba(255, 255, 255, 0.10)',
} as const;

export const text = {
  primary:   ice[100],
  secondary: ice[300],
  muted:     ice[500],
  inverse:   midnight[950],
  accent:    aurora[300],
} as const;

export const brand = {
  primary:      aurora[500],
  primaryHover: aurora[400],
  primaryActive:aurora[600],
  onPrimary:    midnight[950],
} as const;

export type AuroraShade   = keyof typeof aurora;
export type MidnightShade = keyof typeof midnight;
export type IceShade      = keyof typeof ice;
export type SemanticKey   = keyof typeof semantic;
export type WhiteAlphaStep = keyof typeof whiteAlpha;
